// extracted by mini-css-extract-plugin
module.exports = {"freeShippingContainer":"az_nhc","freeDelivery":"az_ohc","freeShippingContainerBorder":"az_phc"};